import { browserName, browserVersion } from "react-device-detect";

export const QValidateBrowser = () => ({
    browserName, browserVersion
})
